module.exports = __webpack_public_path__ + "img/equal@2x.07c870f3.png";